export default __webpack_public_path__ + "media/images/btn-icon7-ea99f83ba06ad5c9f9fbe3d024248746.png";